import { render, staticRenderFns } from "./ZebGradeChart.vue?vue&type=template&id=7ffc8590&scoped=true"
import script from "./ZebGradeChart.vue?vue&type=script&lang=js"
export * from "./ZebGradeChart.vue?vue&type=script&lang=js"
import style0 from "./ZebGradeChart.vue?vue&type=style&index=0&id=7ffc8590&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffc8590",
  null
  
)

export default component.exports